<ng-container *ngIf="junkFeeData">
  <div
    class="row container-full-width"
    [ngClass]="showConnect ? bannerClass.BANNER_CONNECT : bannerClass.BANNER_PREPAID"
  >
    <div class="m-t-md m-b-md w-auto">
      <div [innerHTML]="junkFeeData?.bannerIcon"></div>
      <div class="content-block">
        <div [outerHTML]="junkFeeData?.bannerText"></div>
        <span
          *ngIf="junkFeeData?.isAction"
          class="action"
          [innerHTML]="junkFeeData?.actionContent"
        ></span>
      </div>
    </div>
  </div>
</ng-container>
